/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import {
  EditingState,
  SortingState,
  IntegratedSorting,
  DataTypeProvider,
  SearchState,
  IntegratedFiltering,
  PagingState,
  IntegratedPaging,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  TableHeaderRow,
  TableEditColumn,
  Toolbar,
  SearchPanel,
  DragDropProvider,
  Table,
  TableColumnReordering,
  TableColumnResizing,
  TableColumnVisibility,
  ColumnChooser,
  PagingPanel,
} from '@devexpress/dx-react-grid-material-ui';
import { Command, PopupEditing } from '../../Shared';
import { getRowId, userroles } from '../../common';
import {
  getWorkTickets,
  getProducts,
  createWorkTicket,
  updateWorkTicket,
  deleteWorkTicket,
} from '../../graphql';
import { useLazyQuery, useMutation } from '@apollo/client';
import {
  currencyFormatterEmpty,
  timeFormatter,
  userFormatter,
} from '../../Shared/colorFormat';
import { SearchTable } from '../../components';
import { getColumns } from '../../common/columns';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Snackbar,
  TextField,
  Typography,
} from '@material-ui/core';
import { Fingerprint, Close as CloseIcon } from '@material-ui/icons';
import useEmployees from '../../hooks/useEmployees';
import { useTemplate, useUsers } from '../../hooks';
import { getTasks } from '../../graphql/query';
import { TableComponent } from '../components/TableComponent';
import PopupWorkTicket from '../../pubups/PopupWorkTicket';
import HRContext from '../../contexts/hr';
import { graphqlURI } from '../../constants';

const WorkTickets = forwardRef((props: any, ref: any) => {
  const { isRTL, words, start, end, theme, company } = props;

  const col = getColumns({ isRTL, words });
  const { tempoptions } = useTemplate();

  const [columns] = useState(
    [
      { name: 'time', title: words?.time },
      { name: 'docNo', title: words?.no },
      { name: 'isWorking', title: isRTL ? 'حاضر' : 'Present' },
      { name: 'isAbsent', title: isRTL ? 'غائب' : 'Absent' },
      { name: 'overtime', title: isRTL ? 'اضافي' : 'Overtime' },
      { name: 'deduction', title: isRTL ? 'خصم' : 'Deduction' },
      { name: 'desc', title: words?.description },
      col.userId,
    ].filter((x) => x),
  );

  const [tableColumnExtensions]: any = useState([
    { columnName: 'time', width: 120 },
    { columnName: 'docNo', width: 120 },
    { columnName: 'isWorking', width: 120 },
    { columnName: 'isAbsent', width: 120 },
    { columnName: 'overtime', width: 120 },
    { columnName: 'deduction', width: 120 },
    { columnName: 'desc', width: 200 },
    { columnName: 'userId', width: 150 },
  ]);

  const [rows, setRows] = useState([]);
  const { activeemployees: employees } = useEmployees();
  const { users } = useUsers();

  const {
    state: { hiddenColumnNames },
    dispatch,
  } = useContext(HRContext);

  const setHiddenColumnNames = (hiddenColumns: any) => {
    dispatch({ type: 'setHiddenColumnNames', payload: hiddenColumns });
  };

  const [loadWorkTickets, opData]: any = useLazyQuery(getWorkTickets, {
    fetchPolicy: 'cache-and-network',
  });

  const refresQuery = {
    refetchQueries: [
      {
        query: getWorkTickets,
        variables: {
          start: start ? start.setHours(0, 0, 0, 0) : undefined,
          end: end ? end.setHours(23, 59, 59, 999) : undefined,
        },
      },
      { query: getProducts },
      { query: getTasks },
    ],
  };

  useEffect(() => {
    const variables = {
      start: start ? start.setHours(0, 0, 0, 0) : undefined,
      end: end ? end.setHours(23, 59, 59, 999) : undefined,
    };
    if (start && end) {
      loadWorkTickets({
        variables,
      });
    }
  }, [start, end]);

  const [addWorkTicket] = useMutation(createWorkTicket, refresQuery);
  const [editWorkTicket] = useMutation(updateWorkTicket, refresQuery);
  const [removeWorkTicket] = useMutation(deleteWorkTicket, refresQuery);

  useImperativeHandle(ref, () => ({
    refresh() {
      if (opData?.refetch) {
        opData.refetch();
      }
    },
  }));

  // --- Fingerprint Sync ---
  const [syncOpen, setSyncOpen] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [syncMsg, setSyncMsg] = useState('');
  const [deviceIp, setDeviceIp] = useState(
    localStorage.getItem('fp_device_ip') || '',
  );
  const [devicePort, setDevicePort] = useState(
    localStorage.getItem('fp_device_port') || '80',
  );
  const [deviceUser, setDeviceUser] = useState(
    localStorage.getItem('fp_device_user') || 'admin',
  );
  const [devicePass, setDevicePass] = useState('');

  const saveDeviceSettings = () => {
    localStorage.setItem('fp_device_ip', deviceIp);
    localStorage.setItem('fp_device_port', devicePort);
    localStorage.setItem('fp_device_user', deviceUser);
  };

  const getAuthHeader = () => {
    try {
      const storeRaw = localStorage.getItem('store');
      if (!storeRaw) return '';
      const store = JSON.parse(storeRaw);
      return store?.token ? `Jadwal ${store.token}` : '';
    } catch {
      return '';
    }
  };

  const getFingerprintApiBase = () => {
    try {
      return `${new URL(graphqlURI).origin}/api/fingerprint`;
    } catch {
      return `${window.location.origin}/api/fingerprint`;
    }
  };

  const handleSync = async () => {
    if (!deviceIp || !deviceUser || !devicePass || !start || !end) return;
    setSyncing(true);
    setSyncMsg('');
    saveDeviceSettings();
    try {
      const authHeader = getAuthHeader();
      const resp = await fetch(`${getFingerprintApiBase()}/sync`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: authHeader,
        },
        body: JSON.stringify({
          ip: deviceIp,
          port: Number(devicePort) || 80,
          username: deviceUser,
          password: devicePass,
          start: new Date(start).toISOString(),
          end: new Date(end).toISOString(),
        }),
      });
      const result = await resp.json();
      if (result.ok) {
        setSyncMsg(
          isRTL
            ? `تم مزامنة ${result.data?.synced} سجل حضور (${result.data?.skipped} تم تخطيه)`
            : `Synced ${result.data?.synced} records (${result.data?.skipped} skipped)`,
        );
        if (opData?.refetch) opData.refetch();
      } else {
        setSyncMsg(isRTL ? `خطأ: ${result.error}` : `Error: ${result.error}`);
      }
    } catch (err: any) {
      setSyncMsg(isRTL ? `خطأ في الاتصال` : `Connection error`);
    }
    setSyncing(false);
  };

  const handleTestConnection = async () => {
    if (!deviceIp || !deviceUser || !devicePass) return;
    setSyncing(true);
    setSyncMsg('');
    saveDeviceSettings();
    try {
      const authHeader = getAuthHeader();
      const resp = await fetch(`${getFingerprintApiBase()}/test`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: authHeader,
        },
        body: JSON.stringify({
          ip: deviceIp,
          port: Number(devicePort) || 80,
          username: deviceUser,
          password: devicePass,
        }),
      });
      const result = await resp.json();
      setSyncMsg(
        result.ok
          ? isRTL
            ? 'تم الاتصال بالجهاز بنجاح ✓'
            : 'Device connected successfully ✓'
          : isRTL
            ? `فشل الاتصال: ${result.error}`
            : `Connection failed: ${result.error}`,
      );
    } catch {
      setSyncMsg(isRTL ? 'فشل الاتصال بالجهاز' : 'Cannot reach device');
    }
    setSyncing(false);
  };

  const commitChanges = async ({ deleted }) => {
    if (deleted) {
      const _id = deleted[0];
      removeWorkTicket({ variables: { _id } });
      setRows(rows.filter((row: any) => row._id !== _id));
    }
  };
  useEffect(() => {
    if (opData?.data?.getWorkTickets?.data) {
      const { data } = opData.data.getWorkTickets;
      setRows(data);
    }
  }, [opData]);

  return (
    <>
      <Grid rows={rows} columns={columns} getRowId={getRowId}>
        <SortingState />
        <EditingState onCommitChanges={commitChanges} />
        <SearchState />
        <PagingState defaultCurrentPage={0} defaultPageSize={10} />
        <IntegratedSorting />
        <IntegratedFiltering />
        <IntegratedPaging />
        <DragDropProvider />
        <Table
          messages={{
            noData: isRTL ? 'لا يوجد بيانات' : 'no data',
          }}
          tableComponent={TableComponent}
          rowComponent={(props: any) => (
            <Table.Row {...props} style={{ height: 60 }}></Table.Row>
          )}
          columnExtensions={tableColumnExtensions}
        />

        <TableColumnReordering
          defaultOrder={[
            'time',
            'docNo',
            'isWorking',
            'isAbsent',
            'overtime',
            'bonos',
            'deduction',
            'desc',
            'userId',
          ]}
        />
        <TableColumnResizing defaultColumnWidths={tableColumnExtensions} />

        <TableHeaderRow
          showSortingControls
          titleComponent={({ children }) => {
            return (
              <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                {children}
              </Typography>
            );
          }}
        />
        <TableColumnVisibility
          defaultHiddenColumnNames={hiddenColumnNames}
          hiddenColumnNames={hiddenColumnNames}
          onHiddenColumnNamesChange={setHiddenColumnNames}
        />
        <DataTypeProvider
          for={['time']}
          formatterComponent={timeFormatter}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['userId']}
          formatterComponent={(props: any) =>
            userFormatter({ ...props, users })
          }
        ></DataTypeProvider>
        <DataTypeProvider
          for={['overtime', 'bonos', 'deduction']}
          formatterComponent={currencyFormatterEmpty}
        ></DataTypeProvider>
        <TableEditColumn
          showEditCommand={userroles?.sales?.edit}
          showDeleteCommand={!userroles?.isEmployee && userroles?.sales?.delete}
          showAddCommand={userroles?.sales?.add}
          commandComponent={Command}
        ></TableEditColumn>

        <Toolbar
          rootComponent={(props: any) => (
            <Toolbar.Root
              style={{
                position: 'absolute',
                left: isRTL ? 40 : undefined,
                right: isRTL ? undefined : 40,
                top: 62,
                zIndex: 115,
              }}
              {...props}
            ></Toolbar.Root>
          )}
        />
        <ColumnChooser />
        <PagingPanel
          pageSizes={
            tempoptions?.pageall ? [5, 10, 20, 50, 0] : [5, 10, 20, 50]
          }
        />

        <SearchPanel
          inputComponent={(props: any) => {
            return <SearchTable isRTL={isRTL} {...props}></SearchTable>;
          }}
        />
        <PopupEditing addAction={addWorkTicket} editAction={editWorkTicket}>
          <PopupWorkTicket
            employees={employees}
            company={company}
            theme={theme}
          ></PopupWorkTicket>
        </PopupEditing>
      </Grid>

      {/* Fingerprint Sync Button */}
      <Box
        style={{
          position: 'absolute',
          top: 62,
          left: isRTL ? 180 : undefined,
          right: isRTL ? undefined : 180,
          zIndex: 116,
        }}
      >
        <Button
          size="small"
          variant="outlined"
          color="primary"
          startIcon={<Fingerprint />}
          onClick={() => setSyncOpen(true)}
          style={{ textTransform: 'none', fontSize: 12 }}
        >
          {isRTL ? 'مزامنة البصمة' : 'Sync Fingerprint'}
        </Button>
      </Box>

      {/* Fingerprint Sync Dialog */}
      <Dialog
        open={syncOpen}
        onClose={() => setSyncOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h6">
              {isRTL ? 'مزامنة جهاز البصمة' : 'Fingerprint Device Sync'}
            </Typography>
            <IconButton size="small" onClick={() => setSyncOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" style={{ gap: 12 }}>
            <TextField
              label={isRTL ? 'عنوان IP الجهاز' : 'Device IP'}
              value={deviceIp}
              onChange={(e) => setDeviceIp(e.target.value)}
              variant="outlined"
              size="small"
              placeholder="192.168.1.100"
              fullWidth
            />
            <TextField
              label={isRTL ? 'المنفذ' : 'Port'}
              value={devicePort}
              onChange={(e) => setDevicePort(e.target.value)}
              variant="outlined"
              size="small"
              placeholder="80"
              fullWidth
            />
            <TextField
              label={isRTL ? 'اسم المستخدم' : 'Username'}
              value={deviceUser}
              onChange={(e) => setDeviceUser(e.target.value)}
              variant="outlined"
              size="small"
              fullWidth
            />
            <TextField
              label={isRTL ? 'كلمة المرور' : 'Password'}
              type="password"
              value={devicePass}
              onChange={(e) => setDevicePass(e.target.value)}
              variant="outlined"
              size="small"
              fullWidth
            />
            {syncMsg && (
              <Typography
                variant="body2"
                style={{
                  color:
                    syncMsg.includes('✓') ||
                    syncMsg.includes('تم مزامنة') ||
                    syncMsg.includes('Synced')
                      ? '#2e7d32'
                      : '#c62828',
                  padding: 8,
                  backgroundColor: '#f5f5f5',
                  borderRadius: 4,
                }}
              >
                {syncMsg}
              </Typography>
            )}
            <Typography variant="caption" color="textSecondary">
              {isRTL
                ? `سيتم مزامنة بيانات الحضور للفترة المحددة في شريط التاريخ`
                : `Attendance data will be synced for the selected date range`}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleTestConnection}
            disabled={syncing || !deviceIp || !devicePass}
            color="default"
            variant="outlined"
            size="small"
          >
            {isRTL ? 'اختبار الاتصال' : 'Test Connection'}
          </Button>
          <Button
            onClick={handleSync}
            disabled={syncing || !deviceIp || !devicePass || !start || !end}
            color="primary"
            variant="contained"
            size="small"
            startIcon={
              syncing ? <CircularProgress size={16} /> : <Fingerprint />
            }
          >
            {syncing
              ? isRTL
                ? 'جاري المزامنة...'
                : 'Syncing...'
              : isRTL
                ? 'مزامنة الحضور'
                : 'Sync Attendance'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
});

export default WorkTickets;
